/**
 * ゲーム設定定数
 */
export const GAME_CONFIG = {
  /** 各色のカード枚数構成 */
  CARDS_PER_COLOR: {
    NUMBER: {
      0: 1,  // 0は各色1枚
      1: 2, 2: 2, 3: 2, 4: 2, 5: 2, 6: 2, 7: 2, 8: 2, 9: 2  // 1-9は各色2枚ずつ
    },
    SKIP: 2,       // Skipは各色2枚
    REVERSE: 2,    // Reverseは各色2枚
    DRAW_TWO: 2    // Draw2は各色2枚
  },
  /** ワイルドカード枚数 */
  WILD_CARDS: {
    WILD: 4,            // Wild4枚
    WILD_DRAW_FOUR: 4   // WildDraw44枚
  },
  /** 初期手札枚数 */
  INITIAL_HAND_SIZE: 7,
  /** 色の数 */
  COLORS: 3,  // 赤、緑、黄
  /** プレイヤー数 */
  PLAYERS: 3  // 3人プレイ
} as const;

/**
 * アニメーション速度倍率
 * settingsStore.visual.animationSpeedに対応
 */
export const ANIMATION_SPEED_MULTIPLIER = {
  slow: 1.5,
  normal: 1.0,
  fast: 0.5
} as const;

/**
 * アニメーション設定定数
 */
export const ANIMATION_CONFIG = {
  /** カード配布アニメーション時間（ms） */
  CARD_DEAL_DURATION: 300,
  /** カードプレイアニメーション時間（ms） */
  CARD_PLAY_DURATION: 500,
  /** カードドローアニメーション時間（ms） */
  CARD_DRAW_DURATION: 400,
  /** パーティクルエフェクト時間（ms） */
  PARTICLE_DURATION: 1000,
  /** AI思考時間最小（ms） */
  AI_THINK_MIN: 500,
  /** AI思考時間最大（ms） */
  AI_THINK_MAX: 1500,
  /** AIターン間隔（ms） */
  AI_TURN_DELAY: 800,
  /** ターン遷移モーダル表示までの遅延（ms） */
  TURN_TRANSITION_DELAY: 600,
  /** カード配布間隔（ms） */
  DEAL_STAGGER_DELAY: 100,
  /** ペナルティドロー時の各カード間の遅延（ms） */
  PENALTY_DRAW_STAGGER_DELAY: 200,
  /** アニメーションタイムアウト（ms） */
  ANIMATION_TIMEOUT: 2000
} as const;

/**
 * Phaser設定定数
 */
export const PHASER_CONFIG = {
  /** 画面幅 */
  WIDTH: 1920,
  /** 画面高さ */
  HEIGHT: 1080,
  /** デッキ位置 */
  DECK_POSITION: { x: 700, y: 540 },
  /** 捨て札位置 */
  DISCARD_POSITION: { x: 1220, y: 540 },
  /** カードサイズ */
  CARD_SIZE: { width: 120, height: 180 },
  /** カード間隔 */
  CARD_SPACING: 100
} as const;

/**
 * ネットワーク設定定数
 */
export const NETWORK_CONFIG = {
  /** サーバーURL（本番環境では VITE_SOCKET_URL 環境変数を使用） */
  DEFAULT_SERVER_URL: import.meta.env.VITE_SOCKET_URL || 'http://localhost:3001',
  /** 再接続試行回数 */
  RECONNECT_ATTEMPTS: 5,
  /** 再接続間隔（ms） */
  RECONNECT_DELAY: 1000,
  /** AI置換タイムアウト（ms） - サーバー側と同じ値 */
  AI_REPLACEMENT_TIMEOUT: 30000
} as const;

/**
 * 持ち点システム設定
 */
export const LIFE_POINTS_CONFIG = {
  /** 初期持ち点 */
  INITIAL_POINTS: {
    /** Team 2（1人側）の初期持ち点 */
    TEAM_2_SOLO: 80,
    /** Team 1（2人側）の各プレイヤー初期持ち点 */
    TEAM_1_DUO: 60
  },
  /** カード種別ごとのダメージ値 */
  DAMAGE_VALUES: {
    /** 数字カード: 額面通り（0-9） */
    NUMBER: (value: number) => value,
    /** スキップ */
    SKIP: 20,
    /** リバース */
    REVERSE: 20,
    /** ドロー2 */
    DRAW_TWO: 20,
    /** ワイルド */
    WILD: 40,
    /** ワイルドドロー4 */
    WILD_DRAW_FOUR: 50
  }
} as const;

/**
 * ビューポートスケーリング設定
 */
export const VIEWPORT_CONFIG = {
  /** 基準幅（Phaserの内部解像度と一致） */
  BASE_WIDTH: 1920,
  /** 基準高さ（Phaserの内部解像度と一致） */
  BASE_HEIGHT: 1080,
  /** 最小縮小率（過度な縮小を防止） */
  MIN_SCALE: 0.5,
} as const;

/**
 * チーム表示設定（Phaserオーバーレイ用）
 */
export const TEAM_CONFIG = {
  /** Team 1 カラー */
  TEAM_1_COLOR: 0x4a9eff,
  TEAM_1_COLOR_HEX: '#4a9eff',
  /** Team 2 カラー */
  TEAM_2_COLOR: 0xff6b6b,
  TEAM_2_COLOR_HEX: '#ff6b6b',
  /** Team 1 オーバーレイの透明度 */
  TEAM_1_OVERLAY_ALPHA: 0.08,
  /** Team 1 コネクターラインの透明度 */
  TEAM_1_LINE_ALPHA: 0.4,
  /** Team 1 ラベルY座標 */
  TEAM_1_LABEL_Y: 50,
} as const;
